<template>
	<div>
		<base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9">
			<div class="row">
				<div class="col">
					<div class="card shadow">
						<div class="card-header bg-transparent">
							<div class="d-flex justify-content-between">
								<h3>Catálogo de Clientes</h3>
								<div>
                  <base-button
                    @click="$router.push('/prospects')">
                    Prospectos
                  </base-button>
									<base-button 
                      v-if="[ 'alfredoreyes@canplast.com.mx',
                              'dannasandoval@canplast.com.mx',
                              'darinkahernandez@canplast.com.mx',
                              'federicoflores@canplast.com.mx',
                              'dayanescobar@canplast.com.mx',
                              'danielamuniz@canplast.com.mx',
                              'leslysifuentes@canplast.com.mx' ].includes(this.user.email)"
                      @click="$router.push('/nuevocliente')" 
                      icon="fa fa-plus">
                    Nuevo Cliente
                  </base-button>
								</div>
							</div>
						</div>
              <ag-grid-vue
                v-bind="agCustomers"
                @grid-ready="onGridReady"
                @cell-clicked="onCellClicked"
                @row-double-clicked="onRowDoubleClicked"
                style="height: 70vh;"
                class="ag-theme-alpine mb-4"
              />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
/* eslint-disable vue/no-unused-components */

import AgGrid from "@/mixins/AgGrid.js";
import { AG_GRID_LOCALE_ES } from '@ag-grid-community/locale';
import { AgGridVue } from "ag-grid-vue";
import BaseLoader from "@/components/BaseLoader.vue";
import EmptySection from "@/components/EmptySection.vue";
import axios from 'axios';
import { getAuth } from "firebase/auth";

export default {
  mixins: [AgGrid],
  components: {
    AgGridVue,
    BaseLoader,
    EmptySection,
  },
	data() {
		return {
      user: null,
      salesPersonOptions: null,
      agCustomers: {
        columnDefs: [
          {
            headerName: "Código de Cliente",
            field: "CardCode",
            cellClass: 'ag-clickable-cell text-blue font-weight-bold',
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Cliente",
            field: "CardName",
            width: 500,
            filter: "agTextColumnFilter",
          },
          {
            headerName: "Vendedor",
            field: "SlpCode",
            filter: "agSetColumnFilter",
            filterParams: {
              defaultToNothingSelected: true,
              valueFormatter: this.salesFormatter,
              applyMiniFilterWhileTyping: true,
              values: (params) => {
                const salesPersonCodes = this.salesPersonOptions.map((item) => item.SalesEmployeeCode);
                params.success(salesPersonCodes);
              },
            },
            valueFormatter: this.salesFormatter,
          },
          {
            headerName: "CEDIS",
            field: "U_CEDIS",
            filter: "agTextColumnFilter",
          },
          {
            headerName: "RFC",
            field: "LicTradNum",
            filter: "agTextColumnFilter",
          },
        ],
        defaultColDef: {
          menuTabs: ["filterMenuTab"],
          // suppressHeaderMenuButton: true,
          cellDataType: false,
          floatingFilter: true,
        },
        autoSizeStrategy: {
          type: 'fitGridWidth',
          defaultMinWidth: 100,
        },
        rowModelType: "serverSide",
        cacheBlockSize: 30,
        maxBlocksInCache: 10,
        pagination: true,
        paginationPageSize: 1000,
        paginationPageSizeSelector: [100, 500, 1000, 2000],
        loadingOverlayComponent: "BaseLoader",
        noRowsOverlayComponent: "EmptySection",
        suppressCellFocus: true,
        enableCellTextSelection: true,
        alwaysShowVerticalScroll: true,
        localeText: AG_GRID_LOCALE_ES,
      },
		};
	},
	created() {
    const auth = getAuth();
    this.user = auth.currentUser;
    this.BASE_URL = process.env.VUE_APP_BASE_URL;
    this.HANA_URL = process.env.VUE_APP_HANA_URL;
    this.DATABASE = process.env.VUE_APP_DATABASE;
	},
	methods: {
    onGridReady({api}) {
      axios
      .get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
        api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
      })
      .catch((error) => {
        console.error(error);
      });
    },
    getServerSideDatasource() {
      return {
        getRows: (params) => {
          const { filterModel, endRow, startRow, sortModel } = params.request;

          //SELECT
          const select = `"CardCode", "CardName", "SlpCode", "LicTradNum", "U_CEDIS"`;

          //FILTERS
          let filters = `WHERE "CardType" = 'C' AND "validFor" = 'Y'`;
          const filterModelKeys = Object.keys(filterModel);
          if (filterModelKeys.length) {
            const all = filterModelKeys.reduce((acc, key) => {
              if (filterModel[key].operator) {
                const conditionsArray = filterModel[key].conditions.map((condition) => {
                  return this.formatCondition(condition, key);
                }
              );
              const toPush = "(" + conditionsArray.join(" " + filterModel[key].operator + " ") + ")";
              acc.push(toPush);
              } else {
                const condition = this.formatCondition(filterModel[key], key);
                if(condition){
                  acc.push(condition);
                }
              }
              return acc;
            }, []);
            if(all.length){
              filters += " AND " + all.join(" AND ");
            }
          }

          //PAGINATION
          const pageSize = endRow - startRow;
          const pagination = `LIMIT ${pageSize} OFFSET ${startRow}`;

          //SORTING
          let sorting;
          if (sortModel.length) {
            sorting = `ORDER BY "${sortModel[0].colId}" ${sortModel[0].sort.toUpperCase()}`;
            if(sortModel[0].colId !== "CardCode"){
              sorting += `, "CardCode" ASC`;
            }
          } else {
            sorting = `ORDER BY "CardCode" ASC`;
          }

          //JSON PAYLOADS
          const rowDataJson = {
            query: `
              SELECT ${select}
              FROM ${this.DATABASE}."OCRD"
              ${filters}
              ${sorting}
              ${pagination}
            `
          };
          const totalsJson = {
            query: `
              SELECT COUNT(*) AS "rowCount"
              FROM ${this.DATABASE}."OCRD"
              ${filters}
            `
          };

          // console.log("🟦rowDataJson", rowDataJson.query);
          // console.log("🟦totalsJson", totalsJson.query);
          
          axios
            .all([
              axios.post(`${this.HANA_URL}/api/hana/freedom`, rowDataJson),
              axios.post(`${this.HANA_URL}/api/hana/freedom`, totalsJson),
            ])
            .then(
              axios.spread((rowDataRes, totalsRes) => {
                // console.log("🟪 DATA", rowDataRes.data);
                // console.log("🟪 TOTALS", totalsRes.data);
                params.success({
                  rowData: rowDataRes.data,
                  rowCount: totalsRes.data[0].rowCount,
                });
                
              })
            )
            .catch((err) => {
              console.error(err);
              params.fail();
            });
        },
      };
    },
    onCellClicked({colDef, data}) {
      if (colDef.field === "CardCode") {
        this.$router.push(`/customer/${data.CardCode}`);
      }
    },
    onRowDoubleClicked({data}) {
      this.$router.push(`/customer/${data.CardCode}`);
    },
    salesFormatter({ value }){
      if (!this.salesPersonOptions) {
        return value;
      }
      const salesPerson = this.salesPersonOptions.find((item) => item.SalesEmployeeCode === value);
      return salesPerson ? salesPerson.SalesEmployeeName : value;
    }
	},
}
</script>
<style>
.ag-clickable-cell {
  cursor: pointer !important;
}
.ag-clickable-cell:hover {
  background: #e9ecef !important;
}
</style>